module.exports = __webpack_public_path__ + "static/media/mail-inquiry.2703cbb2.webp";